<template>
  <b-nav-item
    @click.prevent="getSolutionSearch"
    v-b-tooltip.hover="'Solution Search'"
  >
    <b-icon-search variant="light" class="menu-icon" />
  </b-nav-item>
</template>

<script>
//---- components ---------
//---- mixins -------------
//---- services -----------
//---- 3rd-parties --------
import { BIconSearch } from "bootstrap-vue";

export default {
  components: {
    BIconSearch,
  },
  methods: {
    getSolutionSearch() {
      this.$store.dispatch("dsDashboard/getDSSearch").then(() => {
        this.safeRouterPush("/project-home");
      });
    },
  },
};
</script>